import React from "react";
import { useSelector } from "react-redux";

const UserProfile = (props) => {
  const { user } = useSelector(({ auth }) => auth);
  return (
    <div className="gx-flex-row gx-align-items-center gx-mb-4 gx-avatar-row">
      <div>
        <div style={{ fontSize: 16, fontWeight: "bold" }}>{user?.name}</div>
        <div>{user?.userType}</div>
      </div>
      {/* <Popover placement="bottomRight" content={userMenuOptions} trigger="click">
        <span className="gx-avatar-name">{profile.username}<i
          className="icon icon-chevron-down gx-fs-xxs gx-ml-2" /></span>
      </Popover> */}
    </div>
  );
};

export default UserProfile;
